<script lang="ts" generics="ResulType">
    /**
     *  This component allows for easy handling of promised data.
     * It will display a loading spinner until loaded.
     * On error there is an error icon
     * */

    import LoadingSpinner from "./LoadingSpinner.svelte";
    import BootstrapVectorIcon from "./BootstrapVectorIcon.svelte";
    import { onMount } from 'svelte';


    interface Props {
        retrievalPromise: Promise<ResulType>;
        children: import('svelte').Snippet<[any]>;
    }

    let { retrievalPromise, children }: Props = $props();
    
    let result: ResulType = $state();
    let loading = $state(true);

    let error: any = $state(); 

    onMount(() => {
        retrievalPromise.then((v: ResulType) => {
            result = v;
        }).catch((r: any) => {
            error = r;
        }).finally(() => {
            loading = false;
        })

    });
</script>

<LoadingSpinner loaded={!loading}>
    {#if error}
        <BootstrapVectorIcon icon="dash-circle" class="text-danger" style="width: 1em; height: 1em;"></BootstrapVectorIcon>        
    {:else}
        {@render children?.(result)}
    {/if}
</LoadingSpinner>